import { roundNumber } from "src/utils/genericFunctions";
import { HeaderRule } from "../../interface";
import HighlightValue from "./highlightValue";
import { Box } from "@mui/material";
import InputPMR from "./InputPMR";
import theme from "src/themes";

const idMapper = {} as any;

for (let i = 0; i <= 6; i++) {
  idMapper[`${i}-inventory`] = {
    top: `${i}-inventoryBackStore`,
    bottom: `${i}-inventoryCounter`
  };
  idMapper[`${i}-order`] = {
    top: `${i}-order`,
    bottom: `${i}-received`
  };
}

export const VerticalInputPair = (headerItem: HeaderRule, rowData: any) => {
  const topValue =
    rowData[idMapper[headerItem?.id]?.top] === null
      ? "-"
      : roundNumber(rowData[idMapper[headerItem?.id]?.top]);
  const bottomValue =
    rowData[idMapper[headerItem?.id]?.bottom] === null
      ? "-"
      : roundNumber(rowData[idMapper[headerItem?.id]?.bottom]);
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="4px"
      id="vertical-input-pair-container"
    >
      {headerItem?.editMode ? (
        <InputPMR
          rowData={rowData}
          id={idMapper[headerItem?.id]?.top}
          itemId={rowData?.itemId}
          editMode={headerItem?.editMode}
          onBlur={(id: string, itemId: string | number, value: any) =>
            headerItem?.handleBlur(id + "-top", itemId, value)
          }
          disabled={rowData?.inputDisabled?.[headerItem?.id]}
          disableDecimalDigit={false}
          sxConfig={{
            "& .MuiOutlinedInput-input": {
              padding: "4px"
            },
            height: "34px",
            width: "100%",
            fontSize: "14px"
          }}
        />
      ) : (
        <HighlightValue
          value={topValue.toString()}
          color={theme.palette.utility.textPrimary}
          backgroundColor="inherit"
        />
      )}
      {headerItem?.editMode ? (
        <InputPMR
          rowData={rowData}
          id={idMapper[headerItem?.id]?.bottom}
          itemId={rowData?.itemId}
          editMode={headerItem?.editMode}
          onBlur={(id: string, itemId: string | number, value: any) =>
            headerItem?.handleBlur(id + "-bottom", itemId, value)
          }
          disabled={rowData?.inputDisabled?.[headerItem?.id]}
          disableDecimalDigit={false}
          sxConfig={{
            "& .MuiOutlinedInput-input": {
              padding: "4px"
            },
            height: "34px",
            width: "100%",
            fontSize: "14px"
          }}
        />
      ) : (
        <HighlightValue
          value={bottomValue.toString()}
          color={theme.palette.utility.textPrimary}
          backgroundColor="inherit"
        />
      )}
    </Box>
  );
};
